export default __webpack_public_path__ + "static/media/NIAS0170.34I-41301_-24646_0.2d7863b6.jpg";